import React, { useCallback, useEffect, useState } from 'react';

import { retrieveStaffMember } from '../../../../services/StaffMemberService';

import { UserViewGeneralTab } from './UserViewGeneralTab';
import { UserViewRoleAndPermissionsTab } from './UserViewRoleAndPermissionsTab';
import { UserViewSites } from './UserViewSites';
import { BackButton } from '../../../common/button/back-button/BackButton';

import './UsersView.css';

export const UsersView = ({
  context,
  setContext,
  navigateTo,
  showToaster,
  setSpinnerText,
  toolTipsEnabled,
  navigateBack,
}) => {
  const [activeTab, setActiveTab] = useState('userGeneral');
  const [currentScreen, setCurrentScreen] = useState('userGeneral');
  const [user, setUser] = useState({});

  const retrieveUser = useCallback(
    async (username, externalReference) => {
      setSpinnerText('Retrieving User');
      const [data, error] = await retrieveStaffMember(username, externalReference);
      if (data) {
        if (data.responseStatus === 'Success') {
          setUser(data.systemUserVOToView);
          showToaster({
            responseStatus: 'Success',
            responseMessage: 'User Retrieved',
          });
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    },
    [setSpinnerText, showToaster]
  );

  useEffect(() => {
    retrieveUser(context.username, context.additionalContext.externalReference);
  }, [context.username, context.additionalContext, retrieveUser]);

  const handleBack = () => {
    navigateTo('usersTable');
  };

  const handleNavigationClick = (tab) => {
    setActiveTab(tab);
    setCurrentScreen(tab);
  };

  const screenMap = new Map();
  screenMap.set(
    'userGeneral',
    <UserViewGeneralTab user={user} navigateBack={navigateBack} handleNavigationClick={handleNavigationClick} />
  );

  screenMap.set(
    'userRolesAndPermissions',
    <UserViewRoleAndPermissionsTab
      user={user}
      navigateBack={navigateBack}
      handleNavigationClick={handleNavigationClick}
    />
  );
  screenMap.set(
    'userSites',
    <UserViewSites
      context={context}
      setContext={setContext}
      user={user}
      setUser={setUser}
      navigateTo={navigateTo}
      setCurrentScreen={setCurrentScreen}
      navigateBack={navigateBack}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
    />
  );

  return (
    <div className="clients-create-container">
      <div className="clients-create-header-container">
        <BackButton onClick={handleBack} />
        <h2>Edit/View User</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div
                className={'clients-create-tab general ' + (activeTab === 'userGeneral' ? 'active-tab' : null)}
                onClick={() => handleNavigationClick('userGeneral')}
              >
                General
              </div>
              <div
                className={
                  'clients-create-tab ' +
                  'rolesAndPermissions ' +
                  (activeTab === 'userRolesAndPermissions' ? 'active-tab' : null)
                }
                onClick={() => handleNavigationClick('userRolesAndPermissions')}
              >
                Roles & Permissions
              </div>
              <div
                className={'clients-create-tab sites ' + (activeTab === 'userSites' ? 'active-tab' : null)}
                onClick={() => handleNavigationClick('userSites')}
              >
                Sites
              </div>
            </div>
            <div className={'clients-create-tab-content ' + activeTab}>{screenMap.get(currentScreen)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
